import React from 'react'

export default function Live() {
  return (
    <div>live</div>
  )
}
